import { mealCompositionForDiet } from './collettivaMealTemplates.js';

// T-441 / T-445 — AUTO-POPOLAMENTO del trittico (primo/secondo/contorno + frutta/
// bevanda) per una dieta, pescando dal catalogo order_catalog_rows.
//
// ✅ GANCIO AGGANCIATO — la FIRMA è stabile e il CORPO ora usa la LOGICA REALE
// distillata dall'Excel operativo dell'ospedale (`collettivaMealTemplates.ts` →
// `mealCompositionForDiet`, tabella `COLLETTIVA_MEAL_TEMPLATES`). Non più la v1
// "by-name": ogni dieta con template restituisce i piatti esatti del foglio
// (es. diabetica = primo/secondo diabetici ma CONTORNO ordinario + frutta Mela);
// le 8 diete senza template nel foglio restituiscono slot piatto null (bevanda
// "Acqua" o "-"). Firma, chiamanti (Riepilogo/PrepostoReview), schema riga e
// scorporo restano invariati. Il flag `source:'auto'|'manual'` sullo slot permette
// a una futura ri-esecuzione di rispettare le scelte manuali.

export interface CatalogRowLite {
  label: string;
  category: string; // 'PRIMI' | 'SECONDI' | 'CONTORNI' | 'FRUTTA'
  sort_order?: number;
}
export interface TritticoAssignment {
  primo: string | null;
  secondo: string | null;
  contorno: string | null;
  // T-445: composizione a 5 slot. `frutta` + `bevanda` ora valorizzate dalla
  // tabella Excel reale (mealCompositionForDiet). `bevanda` default "Acqua",
  // "-" = nessuna. Opzionali qui per retro-compat con i chiamanti a 3 slot.
  frutta?: string | null;
  bevanda?: string | null;
}

/**
 * Auto-assegna il trittico (5 slot) per una dieta dal catalogo, usando la tabella
 * Excel reale (`mealCompositionForDiet`). Ritorna le LABEL del catalogo (o null se
 * lo slot non è previsto dalla dieta o il piatto non è a catalogo); `bevanda` non è
 * un piatto di catalogo → passa sempre (default "Acqua", "-" = nessuna). Le diete
 * senza template nel foglio restituiscono slot piatto null. Deterministico, DB-free,
 * testabile (vedi collettivaTrittico.test.ts).
 */
export function autoAssignTrittico(dietCode: string, catalog: CatalogRowLite[]): TritticoAssignment {
  const c = mealCompositionForDiet(dietCode, catalog);
  return {
    primo: c.primo,
    secondo: c.secondo,
    contorno: c.contorno,
    frutta: c.frutta,
    bevanda: c.bevanda,
  };
}
